import { IS_NEW_VERSION } from './version'

export const ROUTE_AFFILIATE = 'referal'
export const ROUTE_CASHBACK = 'cashback-v2'
export const ROUTE_COMMISSION = 'commission'
export const ROUTE_CREDIT = 'credit'
export const ROUTE_CONTACT = 'contact'
export const ROUTE_DEPOSIT = 'deposit'
export const ROUTE_GAME_OTHERS = 'game-others'
export const ROUTE_POWER_BALL = 'power-ball'
export const ROUTE_EXTERNAL_CASINO = IS_NEW_VERSION ? 'casino-v2' : 'casino'
export const ROUTE_EXTERNAL_FOOTBALL = IS_NEW_VERSION ? 'football-v2' : 'football'
export const ROUTE_EXTERNAL_SLOT = IS_NEW_VERSION ? 'slot-v2' : 'slot'
export const ROUTE_INTERNAL_LOTTO = IS_NEW_VERSION ? 'lotto-v2' : 'lotto'
export const ROUTE_GAME_LOTTO_DETAIL = IS_NEW_VERSION ? 'lotto-detail-v2' : 'lotto-detail'
export const ROUTE_INDEX = IS_NEW_VERSION ? 'index-v2' : 'index'
export const ROUTE_GAME_TYPE = 'game-type'

export const ROUTE_LAYOUT_DEFAULT_V1 = 'Layout-After-Login-v1'
export const ROUTE_LIST = 'list'
export const ROUTE_LOGIN = IS_NEW_VERSION ? 'login-v2' : 'login'
export const ROUTE_NEWS = 'news'
export const ROUTE_NOTFOUND = 'not-found'
export const ROUTE_OTP = 'otp'
export const ROUTE_RESET_PASSWORD = 'reset-password'
export const ROUTE_RULE = 'rule'
export const ROUTE_PAYRATE = 'payrate'

export const ROUTE_REGISTER_ID_BANK_INFO = 'register-id-bank-info'
export const ROUTE_REGISTER_ID_PERSONAL_INFO = 'register-id-personal-info'
export const ROUTE_REGISTER_ID_USER_INFO = 'register-id-user-info'

export const ROUTE_DEMO_REGISTER_BANK_INFO = 'demo-register-bank-info'
export const ROUTE_DEMO_REGISTER_PERSONAL_INFO = 'demo-register-personal-info'
export const ROUTE_DEMO_REGISTER_USER_INFO = 'demo-register-user-info'

export const ROUTE_REGISTER_BANK_INFO = 'bank-info'
export const ROUTE_REGISTER_PERSONAL_INFO = 'personal-info'
export const ROUTE_REGISTER_USER_INFO = 'user-info'
export const ROUTE_RESULT = 'result'
export const ROUTE_RESULT_DETAIL = 'result-detail'

export const ROUTE_SETTING = 'setting'
export const ROUTE_STATUS = 'status'
export const ROUTE_TEMPLATE_NUMBER = 'template-number'
export const ROUTE_TRASACTION = 'transaction'
export const ROUTE_VOUCHER = 'vouchers'
export const ROUTE_WITHDRAW = 'withdraw'

export const ROUTE_V3_PAYRATE = 'payrate'
export const ROUTE_V3_LOGIN = 'login-v3'
export const ROUTE_V3_REGISTER = 'register-v3'
export const ROUTE_V3_FORGOT_PASSWORD = 'forgot-password-v3'

export const ROUTE_LANDING_PAGE = 'landing_page'

